import axios from "axios";
import instance from "../../../axios";


export const API_URL = `${process.env.REACT_APP_API_URL}/dashboards/contest-list-next`;
// READ
export function getContestForRPList(queryParams) {
  // return axios.post(`${API_URL}`, queryParams);
  return instance.post(`${API_URL}`, queryParams)
    .then(res => {
      return res;
    })
}
